var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustra08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 120,
    viewBox: "0 0 274 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.4 82V111.889C108.4 112.503 107.903 113 107.289 113H97.1111C96.4975 113 96 112.503 96 111.889V82",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.8 82V111.889C125.8 112.503 125.303 113 124.689 113H114.511C113.897 113 113.4 112.503 113.4 111.889V82",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.2 82V111.889C143.2 112.503 142.703 113 142.089 113H131.911C131.298 113 130.8 112.503 130.8 111.889V82",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.6 82V111.889C160.6 112.503 160.102 113 159.489 113H149.311C148.697 113 148.2 112.503 148.2 111.889V82",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178 82V111.889C178 112.503 177.503 113 176.889 113H166.711C166.097 113 165.6 112.503 165.6 111.889V82",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5185 42H79.6667C75.9848 42 73 44.9848 73 48.6667V75.3333C73 79.0152 75.9848 82 79.6667 82H194.333C198.015 82 201 79.0152 201 75.3333V48.6667C201 44.9848 198.015 42 194.333 42H178.481",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.55 30.5L154.152 9.63147M96 53V16.8889C96 11.9797 99.9797 8 104.889 8H150.219C153.495 8 156.06 10.8206 155.75 14.0821L154.708 25.0218C154.351 28.7719 157.751 31.7826 161.43 30.9746L171.253 28.8176C174.719 28.0565 178 30.6954 178 34.2438V53",
    stroke: "#FF6956",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157 55V38.6309C157 38.3945 156.739 38.251 156.54 38.3775L145.698 45.2415C145.585 45.3128 145.439 45.3012 145.339 45.213L135.176 36.2486C135.031 36.1213 134.806 36.161 134.714 36.33L128.218 48.2429C128.154 48.3605 128.02 48.4213 127.889 48.3919L115.523 45.607C115.294 45.5555 115.098 45.7747 115.173 45.9967L118.116 54.6095",
    stroke: "#FF6956",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183 55H91",
    stroke: "#CCCEDE",
    strokeWidth: 3.77778,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustra08);
export default __webpack_public_path__ + "static/media/illustra_08.91d3132c61fa85905c1fda273f668563.svg";
export { ForwardRef as ReactComponent };